import { NgModule } from '@angular/core';
import { ClassForRouteDirective } from './class-for-route.directive';

@NgModule({
  declarations: [ClassForRouteDirective],
  exports: [ClassForRouteDirective],
})
export class RouteDirectiveModule {}
